module.exports = __webpack_public_path__ + "img/info.001.ba3f0d38.jpeg";